import { render, staticRenderFns } from "./bmi.vue?vue&type=template&id=1afe04f8&scoped=true&"
import script from "./bmi.vue?vue&type=script&lang=js&"
export * from "./bmi.vue?vue&type=script&lang=js&"
import style0 from "./bmi.vue?vue&type=style&index=0&id=1afe04f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afe04f8",
  null
  
)

export default component.exports